module.exports = __webpack_public_path__ + "img/Palo-Alto-NGFW.c3b42de.svg";